<!-- ESEMPIO 1 SENZA CARD -->
<!-- <div class="login-container">
  <form [formGroup]="form" class="login-form">
    <div class="image-container">
      <img src="https://placehold.co/200x200" alt="Prenotazione">
    </div>

    <mat-form-field class="input-large">
      <mat-label>Email</mat-label>
      <input type="email" matInput formControlName="email" placeholder="Inserisci l'email">
    </mat-form-field>

    <mat-form-field class="input-large">
      <mat-label>Password</mat-label>
      <input type="password" matInput formControlName="password" placeholder="Inserisci la password">
    </mat-form-field>

    <p class="forgot-password">Password dimenticata?</p>

    <div class="button-container">
      <button mat-flat-button color="primary" class="big-button">ENTRA</button>
    </div>
  </form>
</div> -->

<!-- ESEMPIO 2 CON CARD -->
<div class="full-page">
  <div class="login-container">
    <mat-card class="login-card">
      <mat-card-title class="card-title">Accedi</mat-card-title>
      <form [formGroup]="form" class="login-form">
        <div class="image-container">
          <img src="https://placehold.co/100x100" alt="prenotazione">
        </div>

        <p>Email* :</p>
        <mat-form-field class="input-large" appearance="outline">
          <input type="email" matInput formControlName="username" placeholder="Inserisci l'email">
        </mat-form-field>

        <p>Password* :</p>
        <mat-form-field class="input-large" appearance="outline">
            <button mat-icon-button matPrefix (click)="togglePasswordVisibility()" type="button">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
              <input matTooltip="La password deve contenere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un simbolo."
                [type]="hidePassword ? 'password' : 'text'" 
                matInput formControlName="password" 
                placeholder="Inserisci la password">
        </mat-form-field>

        <h6 class="forgot-password" (click)="openResetPasswordDialog()">Password dimenticata?</h6>
        <h6 class="auth-link">Non sei registrato?  <a (click)="goToRegistration()">Crea un account</a></h6>
        <div class="button-container">
          <button mat-button class="guest" (click)="goToReservations()">CONTINUA COME OSPITE</button>
          <button mat-flat-button color="primary" class="big-button" (click)="onSubmit()">ENTRA</button>
        </div>
      </form>
    </mat-card>
  </div>
</div>





